import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { matches: Array };

  connect() {
    this.expandMatches();
  }

  expandMatches() {
    this.matchesValue.forEach((id) => {
      const optionEl = document.getElementById(`component-${id}`);

      if (optionEl) {
        const categoryGroup = optionEl.closest(".accordion-group");
        const subcategoryGroup = optionEl.closest(".accordion-subgroup");
        const subcategoryHeader = optionEl.parentElement.previousElementSibling;

        if (categoryGroup) categoryGroup.classList.add("is-open");
        if (subcategoryGroup) subcategoryGroup.classList.add("is-open");
        if (subcategoryHeader) subcategoryHeader.classList.add("is-expanded");
      }
    });
  }
}
